import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { batchRequest } from '../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../api/MetricsService';
import { fetchFinancialStatements } from '../../../../../api/FinancialStatementsService';
import Teams from '../../../../../api/Teams';
import Auth from '../../../../../routes/Auth';
import { Loader } from 'react-loaders';

import { formatNumber } from '../../../../../api/PerformanceFeedback';

class GrossMarginsStep5 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      sellingPrice: 0,
      unitCost: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;
    const courseId = Number(Auth.getCourseId());
    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);

    Promise.all([
      fetchTeamMetrics(teamId, roundId),
      fetchFinancialStatements({ roundNumber: activeRound }),
      batchRequest([
        `${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/?round_number=${activeRound}`,
        `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}`,
        `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}`,
      ]),
    ])
      .then(([metricsResults, financialData, batchRes]) => {
        const currentRoundMetrics = metricsResults.find(i => (
          Number(i.game) === gameId && Number(i.round) === roundId
        ));

        const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
        const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
        let sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;

        const incomeStatement = financialData.incomeStatement;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.Round === activeRound);
        const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
        let unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;

        const pfReportRaw = batchRes[0].body;
        const pfReport = pfReportRaw.results.find(i => (
          Number(i.course) === courseId
          && Number(i.game) === gameId
          && Number(i.round) === roundId
          && Number(i.team) === teamId
          && i.type === 'Negative gross margins'
        ));
        if (!!pfReport) {
          const message = JSON.parse(pfReport.message);
          if (message.faild_products && message.faild_products.length > 0) {
            const productId = Number(message.faild_products[0]);
            const priceForecastsRaw = batchRes[1].body;
            const priceForecastsProduct = priceForecastsRaw.find(i => Number(i.product) === productId);
            const inventoryBalancesRaw = batchRes[2].body;
            const inventoryBalancesProduct = inventoryBalancesRaw.find(i => Number(i.product) === productId);

            if (priceForecastsProduct && inventoryBalancesProduct) {
              sellingPrice = Number(priceForecastsProduct.price);
              unitCost = Number(inventoryBalancesProduct.cost_per_unit);
            }
          }
        }

        this.setState({
          loaded: true,
          sellingPrice,
          unitCost,
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      sellingPrice,
      unitCost,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="GROSS MARGINS"
        previousShownErrors={previousShownErrors}
        alertText="You might be running a non-profit or a growth-at-all-cost strategy."
        paragraph2={(
          <Fragment>
            You're selling your product below what it cost for you to make the product.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#4cc7d1" color="rgba(0, 27, 59, 0.94)">
              Gross Profit Margin<br />
              Per Unit of Sale
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Selling Price - Unit Cost
              <span className='divider' />
              Selling Price
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              {formatNumber(sellingPrice - unitCost)}
              <span className='divider' />
              {formatNumber(sellingPrice)}
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#d7f0f2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default GrossMarginsStep5;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step5.js